import styled from 'styled-components';

export const NewAccountPopoverContainer = styled.div`
  width: 45vw;
`;
